<template>
    <div class="card config-section">
        <CardHeader
            title="Parâmetros de Checkout"
            icon="fas fa-sign-out-alt"
        />
        <div class="card-body">
            <div class="section-form">
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label
                                for="minimal_hour_to_checkout"
                                class="form-label"
                            >
                                <span class="required">*</span>
                                Mínimo de horas para checkout antecipado
                            </label>
                            <input
                                id="minimal_hour_to_checkout"
                                type="number"
                                class="form-control"
                                :value="value.minimal_hour_to_checkout"
                                @input="updateField('minimal_hour_to_checkout', $event.target.value)"
                                placeholder="Ex: 1"
                                min="1"
                            />
                            <small class="form-text text-muted">
                                Tempo mínimo antes da devolução programada
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CardHeader from "../../Base/CardHeader.vue";

export default {
    name: 'CheckoutConfig',
    components: {CardHeader},
    props: {
        value: {type: Object, required: true},
    },
    methods: {
        updateField(field, newValue) {
            this.$emit('update', field, newValue);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Parameters/components/CheckoutConfig.vue